import { PAGE_SIZE } from "../../../constants/Config";
import {
    PROMOTION_CARD_DELETE,
    PROMOTION_CARD_DETAIL,
    PROMOTION_CARD_INSERT,
    PROMOTION_CARD_LIST,
    PROMOTION_CARD_UPDATE,
    PROMOTION_CARD_GET_ALL,
    PROMOTION_CARD_GET_ALL_BY_TIME,
} from "./action-types";

const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    item: null,
    suggestion: [],
    getAllByServiceNote: [],
    dataListByTime: [],
};

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case PROMOTION_CARD_LIST:
            return list(state, payload);
        case PROMOTION_CARD_DETAIL:
            return detail(state, payload);
        case PROMOTION_CARD_UPDATE:
            return update(state, payload);
        case PROMOTION_CARD_INSERT:
            return insert(state, payload);
        case PROMOTION_CARD_DELETE:
            return deletes(state, payload);
        case PROMOTION_CARD_GET_ALL:
            return getAll(state, payload);
        case PROMOTION_CARD_GET_ALL_BY_TIME:
            return getAllByTime(state, payload);
        default:
            return state;
    }
};

function list(state, payload) {
    state = Object.assign({}, state, payload);
    return state;
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload,
    });
    return state;
}

function deletes(state, payload) {
    const data = state.data.filter((obj) => obj.UserId !== payload);

    return Object.assign({}, state, { data });
}

function update(state, payload) {
    const data = state.data.map((obj) => {
        if (obj.id === payload.id) {
            return { ...obj, ...payload };
        }
        return obj;
    });

    return Object.assign({}, state, { data });
}

function insert(state, payload) {
    const data = [...state.data, payload];
    return Object.assign({}, state, { data });
}

function getAll(state, payload) {
    state = Object.assign({}, state, { suggestion: payload });
    return state;
}

const getAllByTime = (state, payload) => {
    state = { ...state, dataListByTime: payload };

    return state;
};
export default reducer;
